export default __webpack_public_path__ + "static/media/logo-finanzas.4b772fc3.svg";